import { Component, OnInit } from '@angular/core';

import { DxChartModule } from 'devextreme-angular';

import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { WaterUsage } from '../models/WaterUsage';

import { PowerUsageService } from '../power-usage.service';
import { WaterUsageService } from '../services/water-usage.service';
import { RegistrationService } from '../services/registration.service';
import { LoginService } from '../services/login.service';
import { AccountDetailsService } from '../services/account-details.service';

@Component({
  selector: 'app-power-usage',
  templateUrl: './power-usage.component.html',
  styleUrls: ['./power-usage.component.css']
})
export class PowerUsageComponent implements OnInit {

  waterConsumption: WaterUsage[];
  devices: AccountDeviceModel;
  dataSource: any;
  consumptionType: string = "";
  //test: any;

  constructor(
    private service: PowerUsageService,
    private waterUsageService: WaterUsageService,
    private registrationService: RegistrationService,
    private loginService: LoginService,
    private acctDetailsService: AccountDetailsService
  ) {
    //this.dataSource = service.getWaterUsageData();
    //this.test = service.getTestData().subscribe((res: any) => {
    //  var value = res;
    //});
  }

  customizeDollarLabelText(amnt) {
    return '$' + amnt.valueText;
  }

  customizeGallonsLabelText(amnt) {
    return amnt.value;
  }

  ngOnInit() {
    //this.loginService.getCustomerAccounts().subscribe((accts) => {
    //  if (accts) {
    //    let device: AccountDeviceModel = {
    //      OrgUnitId: accts[0].orgUnitId,
    //      AccountId: accts[0].accountId,
    //      DeviceId: accts[0].deviceId,
    //      TimeRange: '',
    //      CustomDate: null,
    //      Lat: accts[0].lat,
    //      Lon: accts[0].lon,
    //      UtilitySupportEmail: accts[0].utilitySupportEmail,
    //      MeterOperationsEmail: accts[0].meterOperationsEmail,
    //      MeterID: accts[0].meterID,
    //      ServiceDate: accts[0].serviceDate
    //    }

    //    this.waterUsageService.getWaterUsageData(device)
    //      .subscribe((data) => {
    //        if (data) {
    //          let time = data.res.time;
    //          let consumption = data.res.consumptionDetail;
    //          this.dataSource = this.buildOutDataSource(consumption);
    //        }
    //      });

    //    //comsumption type to use in graphs and areas where gal is displayed
    //    this.acctDetailsService.getOrgConsumptionType(device.OrgUnitId.toString())
    //      .subscribe((data) => {
    //        this.consumptionType = data.modelRet.type;
    //        if (data.modelRet.type === "gal") {
    //          this.consumptionType = "GAL";
    //        } else {
    //          this.consumptionType = "Ft3"
    //        }
    //      });
    //  }
    //});

  }

  //getOrgUnitId(acctDevices: AccountDeviceModel) {
  //  this.registrationService.orgUnitId.subscribe(orgUnitId => acctDevices.OrgUnitId = parseInt(orgUnitId));
  //}

  //getAccountId(acctDevices: AccountDeviceModel) {
  //  this.registrationService.accountId.subscribe(acctId => acctDevices.AccountId = parseInt(acctId));
  //}

  //buildOutDataSource(rawData: any): WaterUsage[] {
  //  let usageArry: WaterUsage[] = [];
  //  let self: any = this;
  //  rawData.forEach(function (dat) {
  //    let waterUse: WaterUsage = { date: self.formatDate(dat.display), GPH: dat.count, dollars: (.5 * dat.count) }
  //    usageArry.push(waterUse);
  //  });
  //  return usageArry;
  //}

  //formatDate(date: Date) {
  //  var d = new Date(date),
  //    month = '' + (d.getMonth() + 1),
  //    day = '' + d.getDate(),
  //    year = d.getFullYear();

  //  if (month.length < 2) month = '0' + month;
  //  if (day.length < 2) day = '0' + day;

  //  return [year, month, day].join('-');
  //}

  //customizeTooltip(arg: any) {
  //  return {
  //    text: arg.valueText
  //  };
  //}
}



// WEBPACK FOOTER //
// ./src/app/power-usage/power-usage.component.ts